import React from "react";
//#region types
import { InheritedOrOverriddenTextProps } from "models/propTypes/customerPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const InheritedOrOverriddenText: React.FC<InheritedOrOverriddenTextProps> = ({ value, standardValue }) => {
  const displayStandardValue = UtilsHelper.isEmpty(standardValue)
    ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NotSet)
    : standardValue;

  const displayText = `${LocalizationHelperInstance.getFormattedMessage(
    UtilsHelper.isEmpty(value) ? TranslationKeys.Common.InheritsStandard : TranslationKeys.Common.OverridesStandard
  )}: ${displayStandardValue}`;

  return <>{displayText}</>;
};

export default InheritedOrOverriddenText;
